import { DeviceType } from '@yanolja-rnd/nol-design-system/dist/types/device.types'
import { useState, useEffect } from 'react'
import { getDeviceTypeFromUserAgent } from '~/api/util'

/**
 * SSR-safe hook to get device type
 *
 * 서버와 클라이언트 초기 렌더링에서 동일한 값('etc')을 반환하여
 * hydration 오류를 방지합니다.
 *
 * @returns DeviceType - 'ios' | 'android' | 'etc'
 *
 * @example
 * ```tsx
 * const deviceType = useDeviceType()
 *
 * return <BottomSheet os={deviceType} />
 * ```
 */
export function useDeviceType(): DeviceType {
  // 서버와 클라이언트 초기 렌더링에서 동일한 값 사용
  const [deviceType, setDeviceType] = useState<DeviceType>('etc')

  useEffect(() => {
    // 클라이언트에서만 실제 디바이스 타입 설정
    setDeviceType(getDeviceTypeFromUserAgent())
  }, [])

  return deviceType
}

export default useDeviceType
